import { createAPI } from '../../composable/useAPI';

const api = createAPI();

export const fileService = {
  async get(params) {
    const { data } = await api.get('/api/v2/file', {
      params: { fileBundleSeq: params },
      withCredentials: true,
    });
    return data?.data ?? data;
  },

  async upload(formData) {
    const { data } = await api.post('/api/v2/file/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true,
    });
    return data;
  },

  async download(params) {
    const res = await api.get('/api/v2/file/download', {
        params: { fileSeq: params },
        responseType: 'blob',
        withCredentials: true,
    });
    return { data: res.data, headers: res.headers }; // blob
  },

  async delete(params) {
    const { data } = await api.delete('/api/v2/file/delete', {
      params: { fileSeq: params },
      withCredentials: true,
    });
    
    return data?.status === 200;
  },
};
